import Decimal from "decimal.js"

export default function scaleToPercent(arr) {
    const total = Decimal.sum(...arr)
    const percents = arr.map((num) => Decimal.div(num, total).mul(100)) // Initial percentages
    const summary = Decimal.sum(...percents)

    // Adjust the last percentage to ensure the sum is exactly 100
    if (!summary.eq(100)) {
        const lastIndex = percents.length - 1
        percents[lastIndex] = percents[lastIndex].plus(Decimal.sub(100, summary))
    }

    return percents.map((num) => num.toNumber())
}
